<div class="login-container login-centered forms-design-system buttons-design-system">
  <img class="logo" src="/assets/img/vertical-logo.png" alt="Gamelearn" [routerLink]="['/']" />
  <div class="login-box">
    <div class="login-box__title">
      {{ 'auth.resetPassword' | translate }}
    </div>
    <div class="login-box__back">
      <a
        [routerLink]="['../login']"
        [queryParams]="{ username: credentials.username, sid: credentials.sid }"
        title=""
        class="link"
      >
        <span class="glicon-arrow-right"></span>
      </a>
    </div>
    <div class="login-box__icon" *ngIf="done">
      <span class="glicon-check-circle-thin"></span>
    </div>
    <div class="login-box__description" *ngIf="!done">
      {{ 'auth.resetPasswordDesc' | translate }}
    </div>
    <div class="login-box__description no-padding-top" *ngIf="done">
      {{ 'auth.forgotPasswordSent' | translate }}
    </div>
    <form class="form__passwword" [formGroup]="formGroup">
      <div class="form__group">
        <gl-input
          type="email"
          id="username"
          large
          [value]="usernameQuestion.value"
          [formControlName]="usernameQuestion.key"
          [skeletorValueAccessor]="usernameQuestion"
          class="width--xlarge"
          [attr.disabled]="done ? true : null"
          placeholder="{{ 'auth.email' | translate }}"
          validateOnEdit="true"
        >
        </gl-input>
        <div *ngIf="error" class="form__error">
          <span class="glicon-alert-thin"></span>
          <span>
            <app-dynamic-form-error [formError]="error"> </app-dynamic-form-error>
          </span>
        </div>
      </div>
      <gl-button
        color-primary
        large
        class="margin--top margin--bottom"
        text="{{ 'auth.continue' | translate }}"
        (onClick)="onSubmit()"
        [disabled]="formGroup.invalid || loading || done"
      ></gl-button>
    </form>
    <div class="login-panel__help">
      <span>{{ 'auth.helpQuestion' | translate }}</span>
      <a href="{{ supportUrl }}" target="_blank" title="Support">{{
        'auth.contactLabel' | translate
      }}</a>
    </div>
  </div>
</div>
